import { DatasetPlaceholder } from "~/pages/manifold-nextgen/components/datasets/DatasetPlaceholder";

export const DatasetUserAccess = () => <DatasetPlaceholder label="User Access" />;
